import React from 'react'
import { M_Table } from 'src/M_Components'

const Tax = ({ roles }) => {
  return (
    <M_Table entityName={'tax'} rolePermissions={roles} />
  )
}

export default Tax